import { z } from 'zod';

import { gymIdsSearchSchema } from '@/screens/gym-catalog/gym-catalog-query';

/**
 * What the new-exercise page can be opened with: from "From gyms", the name
 * the gyms wrote and the gym exercises the new catalog row is made from
 * (comma-separated), linked once it exists; from exercise requests, the
 * request whose AI draft fills the form and which the new row resolves.
 * `.catch(undefined)`, so a stale link opens an empty form.
 */
export const exerciseNewSearchSchema = z.object({
  name: z.string().trim().min(1).max(120).optional().catch(undefined),
  gymExerciseIds: gymIdsSearchSchema,
  exerciseRequestId: z.string().uuid().optional().catch(undefined),
});

export type ExerciseNewSearch = z.infer<typeof exerciseNewSearchSchema>;
